import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import Table from 'modules/app_store/pages/QuestionsTemplates/QuestionsTemplates/Table'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import AddSurveyQuestionnaireTemplateModal from 'modules/surveys/components/QuestionTemplates/AddSurveyQuestionnaireTemplateModal'
import SettingsCollectionsBootstrap from 'modules/surveys/lib/SettingsCollectionsBootstrap'
import questionsTemplates from 'modules/surveys/store/collections/questionsTemplates'

const SurveySettings = () => {
  const [isModalOpen, toggleModal] = React.useState<boolean>(false)
  useAsyncData(() => questionsTemplates.fetch(), [])

  const questionsTemplatesList = questionsTemplates.models.filter(
    (questionsTemplate) => questionsTemplate.isSurvey
  )

  return (
    <SettingsCollectionsBootstrap>
      <ResponsivePage.Body>
        <Box alignItems="flexEnd" gap="s24">
          <Button onClick={() => toggleModal(true)} iconName="add">
            {i18n.t('app_store_v2.apps.performance_v2.settings.templates.add')}
          </Button>
          <Table questionsTemplatesList={questionsTemplatesList} />
        </Box>
        {isModalOpen && <AddSurveyQuestionnaireTemplateModal toggleModal={toggleModal} />}
      </ResponsivePage.Body>
    </SettingsCollectionsBootstrap>
  )
}

export default observer(SurveySettings)
